import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function formatCurrency(value) {
    if (value >= 1_000_000) {
        return `$${(value / 1_000_000).toFixed(2)}M`;
    }
    if (value >= 1_000) {
        return `$${(value / 1_000).toFixed(1)}K`;
    }
    return `$${value.toFixed(2)}`;
}
export function formatPercent(value) {
    return `${(value * 100).toFixed(1)}%`;
}
export function formatNumber(value) {
    return new Intl.NumberFormat('en-US').format(Math.round(value));
}
//# sourceMappingURL=utils.js.map